import styled from 'styled-components';
import { Container as AsyncSelectContainer } from 'components/AsyncSelect/styles';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background: ${props => props.theme.cardBackgroud};
  border-radius: 0.4rem;
  margin-top: 1rem;
  .scroll {
    height: calc(100vh - 194px);
    display: flex;
    /* height: auto; */
    width: 100%;
  }
  .freepik {
    height: calc(100vh - 194px);
    margin: 0 auto;
  }
  table {
    height: 1px;
    width: 100%;
    border-collapse: collapse;
    /* overflow: hidden; */
    tbody {
      z-index: 1;
    }
    tr {
      height: 10px;
      z-index: 1;
      th {
        background: ${props => props.theme.table.header};
        color: ${props => props.theme.lightFontColor};
        padding: 0.4rem 0.4rem;
        border: 1px solid ${props => props.theme.componentborder};
        z-index: 1;
      }
      td {
        padding: 0.2rem 0.6rem;
        border: 1px solid ${props => props.theme.componentborder};
        color: ${props => props.theme.table.fontColor};
        strong,
        span,
        a {
          white-space: nowrap;
          color: ${props => props.theme.table.fontColor};
        }
        ${AsyncSelectContainer} {
          width: 100%;
          z-index: 1;
        }
        &:last-of-type {
          border-right: 0px;
        }
        .provided_at {
          display: flex;
          align-items: center;
          justify-content: space-between;
          white-space: nowrap;
          button {
            margin: 0 4px;
          }
        }
      }
    }

    &:nth-of-type(1) {
      /* background: red; */
    }
    &:nth-of-type(2) {
      /* background: green; */
    }
    &:nth-of-type(3) {
      /* background: blue; */
    }
    &:nth-of-type(4) {
      /* background: yellow; */
      td {
        &:last-of-type {
          border-right: 1px solid ${props => props.theme.componentborder};
        }
      }
    }
    .comercialSubstituicao {
      strong {
        margin-left: 5px;
        font-size: 0.88rem;
        font-weight: normal;
        font-style: italic;

        &:before {
          content: '-';
          margin-right: 10px;
        }
      }
    }
  }
`;

interface ColumProps {
  align?: 'center' | 'flex-start' | 'flex-end';
  disabled?: boolean;
  $vetado?: boolean;
}
export const Column = styled.div<ColumProps>`
  display: flex;
  width: 100%;
  flex-direction: column;
  text-transform: uppercase;
  position: relative;
  align-items: ${props => props.align || 'flex-start'};
  text-decoration: ${props => (props.disabled ? 'line-through' : 'none')};
  color: ${props => (props.disabled ? props.theme.secondaryFontColor : 'none')};
  strong {
    white-space: nowrap;
    color: ${props =>
      props.disabled
        ? props.theme.secondaryFontColor
        : props.$vetado
        ? props.theme.error
        : 'none'} !important;
  }
  .codMaterial {
    cursor: pointer;
  }
  a {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.95rem;
    font-weight: bold;
    color: ${props =>
      props.disabled
        ? props.theme.secondaryFontColor
        : props.$vetado
        ? props.theme.error
        : props.theme.fontColor} !important;
  }
  span {
    white-space: nowrap;
    color: ${props =>
      props.disabled
        ? props.theme.secondaryFontColor
        : props.$vetado
        ? props.theme.error
        : 'none'} !important;
  }

  .horario {
    display: flex;
    justify-content: space-between;
    font-size: 0.85rem;
    width: 120px;
    p {
      color: ${props =>
        props.disabled
          ? props.theme.secondaryFontColor
          : props.$vetado
          ? props.theme.error
          : 'none'} !important;
    }
  }
  .mapa {
    display: flex;
    align-items: baseline;
    font-size: 0.85rem;
    p {
      min-width: 80px;
      color: ${props =>
        props.disabled
          ? props.theme.secondaryFontColor
          : props.$vetado
          ? props.theme.error
          : 'none'} !important;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  /* justify-content: center; */
  position: relative;
`;

export const ModalContent = styled.div`
  margin-top: 1rem;

  section {
    display: flex;
    flex-direction: column;
    span {
      font-size: 0.9rem;
      text-transform: capitalize;
      margin: 0.5rem 0;
    }
    strong {
      font-weight: normal;
      font-size: 1rem;
    }

    &:last-of-type {
      margin-top: 0.5rem;
    }
  }
  .actions {
    margin-top: 1rem;
    display: flex;
    justify-content: end;

    button {
      &:last-of-type {
        margin-left: 0.5rem;
      }
    }
  }
`;

export const DesvincularModal = styled.div`
  > div {
    display: flex;
    justify-content: space-between;
    margin-top: 3rem;
  }
`;
